import { Modal } from 'react-bootstrap';
import { scheduleAgentholidays } from '../services/scheduleAgentHolidays';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { staffUsersSelector } from '../../tasks';
import { toast } from 'react-toastify';

enum State {
  IDLE = 'idle',
  LOADING = 'loading',
}
export default function ModalHolidayForm({ visible, onClose, onSubmit }) {
  const intl = useIntl();
  const [state, setState] = useState('idle');
  const staffUsers = useSelector(staffUsersSelector);
  const [request, setRequest] = useState({
    userId: null,
    fromDate: '',
    toDate: '',
    startHour: '00:00',
    endHour: '23:59',
    overwrite: true,
  });

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    try {
      setState(State.LOADING);
      const { data } = await scheduleAgentholidays(request);
      if (data) {
        onSubmit();
        onClose();
        toast.success(intl.formatMessage({ id: 'holiday.success' }));
      }
    } catch (error) {
      console.error('Error scheduling holiday:', error);
      toast.error(intl.formatMessage({ id: 'holiday.error' }));
    } finally {
      setState(State.IDLE);
    }
  }

  return (
    <Modal
      show={visible}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {intl.formatMessage({ id: 'holiday.schedule' })}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          {/* Your form content goes here */}
          <div className="mb-4">
            <label htmlFor="agent" className="form-label">
              {intl.formatMessage({ id: 'holiday.agent' })}
            </label>
            <Select
              id="agent"
              value={
                staffUsers.find((user) => user.id === request.userId)
                  ? {
                      value: request.userId,
                      label: `${staffUsers.find((user) => user.id === request.userId)?.name || ''} ${staffUsers.find((user) => user.id === request.userId)?.last_name || ''} (${staffUsers.find((user) => user.id === request.userId)?.email})`,
                    }
                  : null
              }
              options={staffUsers.map((user) => ({
                value: user.id,
                label: `${user.name || ''} ${user.last_name || ''} (${user.email})`,
              }))}
              placeholder={intl.formatMessage({ id: 'holiday.selectAgent' })}
              isClearable
              isSearchable
              onChange={(option) =>
                setRequest({ ...request, userId: option?.value })
              }
              required
            />
          </div>
          <div className="row">
            <div className="mb-4 col-12 col-md-6">
              <label htmlFor="holidayDate" className="form-label">
                {intl.formatMessage({ id: 'holiday.dateFrom' })}
              </label>
              <input
                type="date"
                className="form-control"
                id="holidayDate"
                value={request.fromDate}
                onChange={(e) =>
                  setRequest({ ...request, fromDate: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-4 col-12 col-md-6">
              <label htmlFor="holidayDateTo" className="form-label">
                {intl.formatMessage({ id: 'holiday.dateTo' })}
              </label>
              <input
                type="date"
                className="form-control"
                id="holidayDateTo"
                value={request.toDate}
                onChange={(e) =>
                  setRequest({ ...request, toDate: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="mb-3 col-12 col-md-6">
              <label htmlFor="holidayStartHour" className="form-label">
                {intl.formatMessage({ id: 'holiday.startHour' })}
              </label>
              <input
                type="time"
                className="form-control"
                id="holidayStartHour"
                defaultValue="00:00"
                onChange={(e) =>
                  setRequest({ ...request, startHour: e.target.value })
                }
                required
              />
            </div>
            <div className="mb-3 col-12 col-md-6">
              <label htmlFor="holidayEndHour" className="form-label">
                {intl.formatMessage({ id: 'holiday.endHour' })}
              </label>
              <input
                type="time"
                className="form-control"
                id="holidayEndHour"
                defaultValue="23:59"
                onChange={(e) =>
                  setRequest({ ...request, endHour: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div className="form-check mt-4">
            <input
              type="checkbox"
              className="form-check-input"
              id="overwriteHoliday"
              checked={request.overwrite}
              onChange={(e) =>
                setRequest({ ...request, overwrite: e.target.checked })
              }
            />
            <label className="form-check-label" htmlFor="overwriteHoliday">
              {intl.formatMessage({ id: 'holiday.overwrite' })}
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={onClose}>
            {intl.formatMessage({ id: 'common.cancel' })}
          </button>
          <button className="btn btn-primary" type="submit">
            {state === State.LOADING
              ? intl.formatMessage({ id: 'common.loading' })
              : intl.formatMessage({ id: 'holiday.scheduleCta' })}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
